<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 48 48"><title>{{title}}</title>
    <g>
      <path :fill="color"
            d="M18.664,46.109l-3.328-2.219L28.596,24L15.336,4.109l3.328-2.219l14,21c0.448,0.672,0.448,1.547,0,2.219 L18.664,46.109z"></path>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: "Chevron Right",
      },
      width: {
        type: [Number, String],
        default: 48,
      },
      height: {
        type: [Number, String],
        default: 48,
      },
      color: {
        type: String,
        default: '#003d57',
      },
    }
  }
</script>
